import { render } from "./DiarySettings.vue?vue&type=template&id=24bf3e89&scoped=true"
import script from "./DiarySettings.vue?vue&type=script&lang=js"
export * from "./DiarySettings.vue?vue&type=script&lang=js"

import "./DiarySettings.vue?vue&type=style&index=0&id=24bf3e89&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24bf3e89"]])

export default __exports__